module.exports = __webpack_public_path__ + "img/yejicalendar.fe4386f8.png";